export const GOOGLE_MAPS_API_KEY = 'AIzaSyDDL0LW8lVLA0Gr26Cd-nvaDTSBcj6h6Oo';
export const GOOGLE_MAPS_MAPID = '62ec9ba07426c526'; 
export const GOOGLE_PLACE_ID = 'ChIJPdkIqNhbTg0ReO5tgndCKUc';
export const GOOGLE_CALENDAR_LINK = 'https://calendar.app.google/une5Tq85SPMkywt1A';
